import React from 'react'
import ReactDOM from 'react-dom'

class SearchBar extends React.Component {
    constructor(props) {
      super(props);
      this.state = {value: ''};
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    handleSubmit(event) {
      event.preventDefault();
      window.location.href='https://artmuseum.princeton.edu/search/collections?mainSearch="' + this.state.value + '"&cultureList=["' + this.props.culture + '"]'
    }
  
    render() {
      if (this.props.culture) {
        return (
          <form onSubmit={this.handleSubmit}>
            <label>
              <input 
                type="text" 
                className="searchbar" 
                value={this.state.value} 
                onChange={this.handleChange} 
                style={{'margin-right':'4px'}}
                placeholder={`Search ${this.props.culture} art`}
              />
            </label>
            <input type="submit" value="Search" name="Submit" id="frm-submit" />
          </form>
        );
      } else {
        return null
      }
    }
  }

export default SearchBar


// WEBPACK FOOTER //
// ./src/components/SearchBar.js